import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getAdminCustomers = async (params) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.CUSTOMERS.GET_ALL, { params });
    return response.data;
};
export const getAdminCustomerById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.CUSTOMERS.GET_BY_ID(id));
    return response.data;
};
export const createCustomer = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.CUSTOMERS.CREATE, data);
    return response.data;
};
export const updateCustomer = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.CUSTOMERS.UPDATE(id), data);
    return response.data;
};
export const deleteCustomer = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.CUSTOMERS.DELETE(id));
    return response.data;
};

